import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Typography, Box, Paper } from '@mui/material';

import {
  clearModuleNavigation,
  ModuleNavigationType,
  removeModuleNavigation,
} from 'services/moduleNavigation';
import { ModuleNavigation } from 'app/components/AppBar/components';
import { Routes } from '../../navigation/routes';

interface TransferOrdersPageComponent extends React.FunctionComponent {
  route: typeof Routes.TransferOrdersPage;
}

const TransferOrdersPage: React.FC = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(clearModuleNavigation(ModuleNavigationType.Materials));

    return () => {
      dispatch(removeModuleNavigation());
    };
  }, [dispatch]);

  return (
    <>
      <ModuleNavigation />
      <Box data-qa="transfer-orders-page" sx={{ p: 3 }}>
        <Typography
          data-qa="transfer-orders-page-title"
          variant="h4"
          gutterBottom
        >
          Transfer Orders
        </Typography>
        <Paper sx={{ p: 3, mt: 2 }}>
          <Typography variant="h6" gutterBottom>
            Transfer Orders Coming Soon
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Transfer Orders functionality will be implemented in upcoming
            releases. This feature will enable inventory movement between
            internal and external locations with support for both MTO (Move
            Transfer Orders) and STO (Ship Transfer Orders).
          </Typography>
        </Paper>
      </Box>
    </>
  );
};

(TransferOrdersPage as TransferOrdersPageComponent).route =
  Routes.TransferOrdersPage;

export default TransferOrdersPage as TransferOrdersPageComponent;
